/* eslint-disable  array-callback-return */
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Dropzone from "react-dropzone";
import { Button, TextField } from "@veriff/genoma";
import "./UploadPage.css";
import UploadStatus from "./UploadStatus/UploadStatus";
import FinishPage from "../FinishPage/FinishPage";
import ErrorPages from "../ErrorPages/ErrorPages";
import ProgressBar from "./ProgressBar/ProgressBar";
import Header from "./Header/Header";
import Page from "./Page/Page";
import MiniUploadPage from "./MiniUploadPage";
import {completeUpload, getPostUrl, validatePostUrl, generatePath, upload2S3Post, sleep} from "../api/api.js";

const itemsPerPage = 10;
const fileLimit = 300;

const UploadPage = () => {
    const [token, setToken] = useState(null);
    const [dropTriggered, setDropTriggered] = useState(false);
    const [folders, setFolders] = useState(null);
    const [files, setFiles] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadFlowSuccessful, setUploadFlowSuccessful] = useState(false);
    const [uploadCount, setUploadCount] = React.useState(0);
    const [uploadComplete, setUploadComplete] = React.useState(false);
    const [pathError, setPathError] = React.useState(false);
    const [pathCharError, setPathCharError] = React.useState(false);
    const [fileSizeError, setFileSizeError] = React.useState({ active: false, filename: "" });
    const [lightUpload, setLightUpload] = React.useState(false);
    const [files4LightUpload, setFiles4LightUpload] = React.useState(null);
    const [newNames, setNewNames] = React.useState({});
    const [uploadProgress, setUploadProgress] = React.useState({});
    const [uploadError, setUploadError] = React.useState({});
    const [folderUploadStatus, setFolderUploadStatus] = React.useState({});
    const [isCardCollapsed, setIsCardCollapsed] = React.useState({});
    const [renameStatus, setRenameStatus] = React.useState({});
    const [firstPass, setFirstPass] = React.useState(false);
    const [dropZoneStyle, setDropZoneStyle] = React.useState("dropzone-default");
    const [currentPage, setCurrentPage] = React.useState(1);
    const [pageNumbers, setPageNumbers] = React.useState(null);
    const [visibleFolders, setVisibleFolders] = React.useState(null);

    useEffect(() => {
        let windowUrlPath = window.location.pathname;
        windowUrlPath = windowUrlPath.substring(3);
        const tokenString = `Bearer ${windowUrlPath}`;
        setToken(tokenString);
        window.Intercom("boot", {
            app_id: "yn2gxy8s",
        });
    }, []);

    useEffect(() => {
        if (files && uploadCount === files.length) {
            completeUpload(token);
            setUploadComplete(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadCount]);

    useEffect(() => {
        if (folders) {
            const indexOfLastItem = currentPage * itemsPerPage;
            const indexOfFirstItem = indexOfLastItem - itemsPerPage;
            const visibleItems = folders.slice(indexOfFirstItem, indexOfLastItem);
            setVisibleFolders(visibleItems);
        }
    }, [currentPage, folders]);

    useEffect(() => {
        if (files && files.length > 0) {
            uploadFiles();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    useEffect(() => {
        folders &&
            folders.forEach((folder) => {
                let errorSt = false;
                let progressSt = false;
                let doneSt = true;
                let result = "";

                files.forEach((file) => {
                    if (file.path.includes(`${folder}/`)) {
                        if (uploadError[file.path] && !uploadError[file.path].isOk) {
                            errorSt = true;
                        } else if (uploadProgress[file.path] && uploadProgress[file.path].state === "pending") {
                            progressSt = true;
                        } else if (!uploadProgress[file.path]) {
                            progressSt = true;
                        } else if (uploadProgress[file.path] && !uploadProgress[file.path].state === "done") {
                            doneSt = false;
                        }
                    }
                });

                if (errorSt) {
                    result = "error";
                } else if (progressSt) {
                    result = "pending";
                } else if (doneSt) {
                    result = "success";
                }

                const checkResult = {
                    status: result,
                };

                setFolderUploadStatus((prevState) => ({ ...prevState, [folder]: checkResult }));
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadError, uploadProgress]);

    const handleDrop = async (acceptedFiles) => {
        for (let a = 0; a <= acceptedFiles.length - 1; a += 1) {
            if (acceptedFiles[a].path.includes(" ")) {
                setPathCharError(true);
                break;
            } else if (acceptedFiles[a].size > 18870000) {
                setFileSizeError({ active: true, filename: acceptedFiles[a].path });
                break;
            }
        }

        if (acceptedFiles.length < fileLimit) {
            const folderList = [];
            const pageNumberList = [];
            let folderMatchCounter;
            setFiles(acceptedFiles);

            for (let i = 0; i <= acceptedFiles.length - 1; i++) {
                folderMatchCounter = 0;
                const folderStr = await getFolderName(acceptedFiles[i].path);

                for (let f = 0; f <= folderList.length - 1; f += 1) {
                    if (folderList[f] === folderStr) {
                        folderMatchCounter += 1;
                    }
                }
                if (folderMatchCounter === 0) {
                    folderList.push(folderStr);
                }
            }

            for (let p = 1; p <= Math.ceil(folderList.length / itemsPerPage); p++) {
                pageNumberList.push(p);
            }
            setPageNumbers(pageNumberList);
            setFolders(folderList);
            folderList.forEach((folder) => {
                // Setting initial values for isCardCollapsed
                setIsCardCollapsed((prevState) => ({ ...prevState, [folder]: true }));
            });
            setDropTriggered(true);
        } else if (acceptedFiles.length >= fileLimit) {
            setLightUpload(true);
            setDropTriggered(true);
            setFiles4LightUpload(acceptedFiles);
        }
    };

    const getFolderName = (fpath) => {
        try {
            const pathBranchCount = fpath.split("/").length - 1;
            if (pathBranchCount <= 2) {
                setPathError(true);
            }

            let folderString = fpath.substring(1);
            const firstIndex = folderString.indexOf("/") + 1;
            const lastIndex = folderString.lastIndexOf("/");
            folderString = folderString.substring(firstIndex, lastIndex);
            return folderString;
        } catch (err) {
            return { errorlog: err };
        }
    };

    async function uploadFiles() {
        setUploading(true);
        setFirstPass(true);

        let postParams;
        let validator;
        let upError;

        try {
            for (let i = 0; i <= files.length - 1; i += 1) {
                postParams = await getPostUrl(files[i].path, token);
                validator = await validatePostUrl(postParams);
                await sleep(300);

                upError = {
                    isOk: validator.isOk,
                    data: validator.data,
                    code: validator.code,
                };
                // Will disable eslint rule for timebeing ... Will check later
                // eslint-disable-next-line
                setUploadError((prevState) => ({ ...prevState, [files[i].path]: upError }));

                if (validator.isOk) {
                    const initialState = {
                        state: "pending",
                    };
                    setUploadProgress((prevState) => ({ ...prevState, [files[i].path]: initialState }));

                    const respUpload2S3Post = await upload2S3Post(postParams.signed_url, files[i]);
                    if (respUpload2S3Post.ok === true) {
                        setUploadCount((prevState) => prevState + 1);
                        const prog = { state: "done" };

                        setUploadProgress((prevState) => ({ ...prevState, [files[i].path]: prog }));

                        const upError = {
                            isOk: true,
                            data: "All Good",
                            code: 200,
                        };
                        setUploadError((prevState) => ({ ...prevState, [files[i].path]: upError }));
                    } else {
                        const prog = { state: "error" };

                        setUploadProgress((prevState) => ({ ...prevState, [files[i].path]: prog }));

                        const upError = {
                            isOk: false,
                            data: respUpload2S3Post.data,
                            code: 3000,
                        };
                        setUploadError((prevState) => ({ ...prevState, [files[i].path]: upError }));
                    }
                }
            }
            setUploading(false);
            setUploadFlowSuccessful(true);
        } catch (err) {
            setUploading(false);
        }
    }

    const switchFolderClass = (state) => {
        switch (state) {
            case "error":
                return "folder-card-error";

            case "success":
                return "folder-card-success";

            default:
                return "folder-card";
        }
    };

    const handleRenameClick = (fname, fpath) => {
        let warning = "Name should include one of (front | back | face | udocs)";
        setNewNames((prevState) => ({ ...prevState, [fpath]: fname }));
        const rename = {
            status: true,
            newName: fname,
            warning: warning,
        };
        setRenameStatus((prevState) => ({ ...prevState, [fpath]: rename }));
    };

    const renameFile = async (fpath, newName) => {
        setNewNames((prevState) => ({ ...prevState, [fpath]: newName }));
        let warning = "";
        const path = await generatePath(fpath, newName);
        if (!(newName.includes("front") || newName.includes("back") || newName.includes("face") || newName.includes("udocs"))) {
            warning = "Name should include one of (front | back | face | udocs)";
        } else if (!(newName.includes(".png") || newName.includes(".jpg") || newName.includes(".jpeg") || newName.includes(".pdf"))) {
            warning = "Please add extension to the file name (png | jpg | jpeg | pdf)";
        } else {
            files.forEach((file) => {
                if (file.path === path) {
                    warning = "This file already exist, please set a unique name.";
                }
            });
        }

        const rename = {
            status: true,
            newName: newName,
            newPath: path,
            warning: warning,
        };
        setRenameStatus((prevState) => ({ ...prevState, [fpath]: rename }));
    };

    const reUploadFile = async (fpath) => {
        if (renameStatus[fpath]) {
            const rename = {
                status: false,
            };
            setRenameStatus((prevState) => ({ ...prevState, [fpath]: rename }));
        }

        if (uploadError && uploadError[fpath]) {
            let path;

            files.map(async (file) => {
                if (fpath === file.path) {
                    path = fpath;

                    if (uploadError[fpath].code === 2000 || (newNames && newNames[file.path])) {
                        path = renameStatus[fpath].newPath;
                    }
                    const postParams = await getPostUrl(path, token);
                    const validator = await validatePostUrl(postParams);
                    const upError = {
                        isOk: validator.isOk,
                        data: validator.data,
                        code: validator.code,
                    };
                    setUploadError((prevState) => ({ ...prevState, [file.path]: upError }));
                    if (validator.isOk) {
                        const respReUploadS3 = await upload2S3Post(postParams.signed_url, file);
                        if (respReUploadS3.ok === true) {
                            setUploadCount((prevState) => prevState + 1);
                            const prog = { state: "done" };

                            setUploadProgress((prevState) => ({ ...prevState, [file.path]: prog }));

                            const upError = {
                                isOk: true,
                                data: "All Good",
                                code: 200,
                            };
                            setUploadError((prevState) => ({ ...prevState, [file.path]: upError }));
                        } else {
                            const prog = { state: "error" };
                            setUploadProgress((prevState) => ({ ...prevState, [file.path]: prog }));

                            const upError = {
                                isOk: false,
                                data: respReUploadS3.data,
                                code: 3000,
                            };

                            setUploadError((prevState) => ({ ...prevState, [file.path]: upError }));
                        }
                    }
                }
            });
        }
    };

    const renderFileName = (fpath, fname) => {
        if (renameStatus && renameStatus[fpath] && !renameStatus[fpath].status) {
            return <div className="file-name">{newNames[fpath]}</div>;
        } else if (renameStatus && renameStatus[fpath] && renameStatus[fpath].status === true) {
            return null;
        } else {
            return <div className="file-name">{fname}</div>;
        }
    };

    const paginate = (num) => {
        setCurrentPage(num);
    };

    const handleAccordionToggle = (rowID) => {
        setIsCardCollapsed((prevState) => ({ ...prevState, [rowID]: !isCardCollapsed[rowID] }));
    };

    if (!dropTriggered) {
        return (
            <div>
                <Header />
                <div className="instructions">
                    <h2 className="instructions-title">Upload your files</h2>
                    <p className="instructions-desc">Remember to use same folder/file structure as instructed before</p>
                </div>
                <Dropzone
                    accept={["image/*","application/pdf"]}
                    noClick={true}
                    onDrop={handleDrop}
                    onDragEnter={() => {
                        setDropZoneStyle("dropzone-drag-enter");
                    }}
                    onDragLeave={() => {
                        setDropZoneStyle("dropzone-drag-leave");
                    }}
                >
                    {({ getRootProps, getInputProps }) => (
                        <section
                            className="dropzone"
                            onMouseEnter={() => {
                                setDropZoneStyle("dropzone-mouse-enter");
                            }}
                            onMouseLeave={() => {
                                setDropZoneStyle("dropzone-mouse-leave");
                            }}
                        >
                            <div className={dropZoneStyle} {...getRootProps()}>
                                <input {...getInputProps()} />

                                <img
                                    className="dropzone-inst-icon"
                                    alt="folder-icon"
                                    src="/icon-folder-and-files.svg"
                                />

                                <h3 className="dropzone-inst-desc">Drag your folder here for upload</h3>
                                <em className="dropzone-inst-desc">
                                    PNG, JPG, JPEG and PDF are supported.
                                    <br></br> Keep the images under 18 MB.
                                </em>
                            </div>
                        </section>
                    )}
                </Dropzone>
            </div>
        );
    } else if (dropTriggered && pathError) {
        return <ErrorPages errorCode={7001} />;
    } else if (dropTriggered && pathCharError) {
        return <ErrorPages errorCode={7002} />;
    } else if (dropTriggered && fileSizeError.active === true) {
        return <ErrorPages errorCode={7003} filename={fileSizeError.filename} />;
    } else if (dropTriggered && lightUpload) {
        return <MiniUploadPage files={files4LightUpload} token={token} />;
    } else if (dropTriggered && !lightUpload && !uploadComplete) {
        return (
            <div>
                <Header />
                <div className="upload-page-info">
                    <h2 className="upload-page-title">Uploading</h2>
                    <p className="upload-page-desc">
                        Your files are being uploaded. We will let you know when it’s done.
                    </p>
                </div>
                <div className="progressContainer">
                    {files && <ProgressBar uploadedCount={uploadCount} fileCount={files.length} />}
                </div>

                <div className="folders">
                    {visibleFolders &&
                        visibleFolders.map((folder) => {
                            return (
                                <Accordion defaultActiveKey="0">
                                    <Card
                                        key={folder}
                                        className={
                                            folderUploadStatus &&
                                            folderUploadStatus[folder] &&
                                            switchFolderClass(folderUploadStatus[folder].status)
                                        }
                                    >
                                        <Accordion.Toggle
                                            className="card-header"
                                            onClick={() => handleAccordionToggle(folder)}
                                            as={Card.Header}
                                            eventKey={folder}
                                        >
                                            <img alt="folder-icon" src="/icon-folder.svg" />
                                            {folder}
                                            {isCardCollapsed[folder] &&
                                                folderUploadStatus &&
                                                folderUploadStatus[folder] && (
                                                    <UploadStatus
                                                        type="folder"
                                                        status={folderUploadStatus[folder].status}
                                                        uploadStarted={uploading}
                                                        uploadFlowOk={uploadFlowSuccessful}
                                                    />
                                                )}
                                        </Accordion.Toggle>
                                        {files.map((file) => {
                                            if (file.path.includes(`${folder}/`)) {
                                                return (
                                                    <Accordion.Collapse eventKey={folder}>
                                                        <Card.Body
                                                            key={file.path}
                                                            className={
                                                                uploadError &&
                                                                uploadError[file.path] &&
                                                                uploadError[file.path].isOk
                                                                    ? "file-card"
                                                                    : "file-card-with-error"
                                                            }
                                                        >
                                                            {(file.name.includes("face") ||
                                                                (newNames &&
                                                                    newNames[file.path] &&
                                                                    newNames &&
                                                                    newNames[file.path].includes("face"))) && (
                                                                <img alt="folder" src="/icon-file-green.svg" />
                                                            )}
                                                            {(file.name.includes("front") ||
                                                                (newNames &&
                                                                    newNames[file.path] &&
                                                                    newNames &&
                                                                    newNames[file.path].includes("front"))) && (
                                                                <img alt="folder" src="/icon-file-yellow.svg" />
                                                            )}
                                                            {(file.name.includes("back") ||
                                                                (newNames &&
                                                                    newNames[file.path] &&
                                                                    newNames &&
                                                                    newNames[file.path].includes("back"))) && (
                                                                <img alt="folder" src="/icon-file-purple.svg" />
                                                            )}
                                                            {(file.name.includes("udocs") ||
                                                                (newNames &&
                                                                    newNames[file.path] &&
                                                                    newNames &&
                                                                    newNames[file.path].includes("udocs"))) && (
                                                                <img alt="folder" src="/icon-file-yellow.svg" />
                                                            )}
                                                            {renderFileName(file.path, file.name)}
                                                            {renameStatus &&
                                                                renameStatus[file.path] &&
                                                                renameStatus[file.path].status === true && (
                                                                    <div className="rename-container">
                                                                        <TextField
                                                                            className="text-field"
                                                                            error={renameStatus[file.path].warning}
                                                                            caption="Rename the file"
                                                                            value={newNames[file.path]}
                                                                            onChange={(e) =>
                                                                                renameFile(file.path, e.target.value)
                                                                            }
                                                                        />
                                                                        <Button
                                                                            className="reupload-button"
                                                                            onClick={() => reUploadFile(file.path)}
                                                                        >
                                                                            SAVE
                                                                        </Button>
                                                                    </div>
                                                                )}

                                                            {uploadError &&
                                                                uploadError[file.path] &&
                                                                uploadError[file.path].code >= 2000 &&
                                                                uploadError[file.path].code < 3000 &&
                                                                !(
                                                                    renameStatus &&
                                                                    renameStatus[file.path] &&
                                                                    renameStatus[file.path].status === true
                                                                ) && (
                                                                    <img
                                                                        className="icon-button"
                                                                        onClick={() =>
                                                                            handleRenameClick(file.name, file.path)
                                                                        }
                                                                        alt="edit"
                                                                        src="/icon-edit.svg"
                                                                    />
                                                                )}
                                                            {uploadError &&
                                                                uploadError[file.path] &&
                                                                uploadError[file.path].code >= 3000 && (
                                                                    <img
                                                                        className="icon-button"
                                                                        onClick={() => reUploadFile(file.path)}
                                                                        alt="repeat"
                                                                        src="/icon-repeat.svg"
                                                                    />
                                                                )}
                                                            {firstPass && uploadError[file.path] && (
                                                                <div className="upload-error">
                                                                    <UploadStatus
                                                                        type="file"
                                                                        info={uploadError[file.path]}
                                                                        progress={uploadProgress[file.path]}
                                                                        uploadStarted={uploading}
                                                                        uploadFlowOk={uploadFlowSuccessful}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                );
                                            }
                                        })}
                                    </Card>
                                </Accordion>
                            );
                        })}
                </div>
                {folders.length >= itemsPerPage && (
                    <Page activePageNum={currentPage} pageNumbers={pageNumbers} paginate={paginate} />
                )}
            </div>
        );
    } else if (dropTriggered && uploadComplete) {
        return <FinishPage />;
    }
};

export default withRouter(UploadPage);
